import { Check } from "lucide-react";

const points = [
  "Deep roots in India's social sector. We understand field realities: shared phones, low literacy, 22 languages.",
  "A full-stack approach: mindset change, DP team setup, data clean-up, consent tooling, and independent certification.",
  "Anumati, our consent manager POC, turns the hardest DPDP requirement, provable consent, into one API call.",
  "Practical, not preachy: guidance grounded in the DPDP Act 2023 and Rules 2025, built for multi-site organisations.",
];

export const WhyDhwani = () => (
  <section id="why-dhwani" className="py-24">
    <div className="max-w-[1120px] mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
      <div>
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B32] bg-[#FBEAEE] px-3 py-1 rounded-full">Why Dhwani</span>
        <h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight">Built for the organisations the Act is hardest on.</h2>
        <p className="mt-4 text-base md:text-lg text-[#5C5F6B] leading-relaxed">
          Big, multi-site organisations have the most collection points, the most partners, and the most old data piling
          up. That's exactly where we work.
        </p>
        <ul className="mt-7 space-y-4">
          {points.map((p, i) => (
            <li key={i} className="flex gap-3 text-[15px] text-[#5C5F6B] leading-relaxed" data-testid={`why-dhwani-point-${i}`}>
              <span className="w-6 h-6 rounded-full bg-[#FBEAEE] grid place-items-center text-[#9E1B32] shrink-0 mt-0.5">
                <Check size={14} />
              </span>
              {p}
            </li>
          ))}
        </ul>
      </div>
      <div className="relative">
        <img
          src="https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBidXNpbmVzcyUyMHByb2Zlc3Npb25hbHN8ZW58MHx8fHwxNzgzNzQwODk3fDA&ixlib=rb-4.1.0&q=85"
          alt="Dhwani RIS team working with an organisation"
          className="rounded-[14px] border border-[#E7E7EC] shadow-[0_24px_48px_-12px_rgba(16,24,40,0.18)] w-full object-cover aspect-[4/3]"
        />
        <div className="absolute -bottom-5 -left-5 bg-white border border-[#E7E7EC] rounded-[14px] px-5 py-4 shadow-[0_8px_30px_rgb(0,0,0,0.08)]">
          <div className="text-2xl font-extrabold tracking-tight text-[#9E1B32]">18 months</div>
          <div className="text-xs text-[#9498A3] font-medium">to full enforcement. Start now</div>
        </div>
      </div>
    </div>
  </section>
);

export default WhyDhwani;
